<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Information for National Health Insurance Holders (NHIS)</h3>
            <p class="depth">Patients covered by the Korean National Health Insurance (NHIS) should bring a referral letter from a local doctor and submit it to the registration desk to have insurance benefits. Otherwise, you will need to see a doctor first at the department of family medicine. The referral letter is valid only for the department with the medical opinion, and if you want to get treatment from another department, you should bring a referral letter with the medical opinion of the relevant department.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Information for Private Insurance Holders</h3>
            <p class="depth">Patients who hold private insurance will be required to pay upfront and then file a claim to your insurance company for reimbursement.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>